import { AriaAttributes, MouseEventHandler, ReactNode } from 'react';

import clsx from 'clsx';

import { DEFAULT_AVATAR_ID } from '../../constants';
import { Props as UserAvatarProps } from '../UserAvatar/index';
import UserAvatar from '../UserAvatar/index';
import { Action, Content, Root, Subtitle, Title, userCellClasses } from './styles';

export type UserCellProps = AriaAttributes & {
  id?: string;
  className?: string;
  classes?: {
    root?: string;
    title?: string;
    avatar?: string;
    action?: string;
    subtitle?: string;
    content?: string;
  };
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  /** name is used for displaying initials, name is not directly displayed anywhere */
  name?: string;
  edge?: 'start' | 'end';
  avatar?: string | UserAvatarProps | typeof DEFAULT_AVATAR_ID;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  /** @default 'medium' */
  size?: 'large' | 'medium';
  tabIndex?: number;
};

export { userCellClasses };

const UserCell = ({
  id,
  classes,
  className,
  onClick,
  avatar,
  title,
  subtitle,
  action,
  name,
  size = 'medium',
  ...props
}: UserCellProps) => {
  return (
    <Root
      id={id}
      {...props}
      className={clsx(className, userCellClasses.root, classes?.root, {
        [userCellClasses.sizeMedium]: size === 'medium',
        [userCellClasses.sizeLarge]: size === 'large',
      })}
      onClick={onClick}
    >
      {avatar != null && (
        <UserAvatar
          variant="rounded"
          className={clsx(userCellClasses.avatar, classes?.avatar)}
          avatarId={typeof avatar === 'string' ? avatar : avatar?.avatarId ?? ''}
          bucketUrl={typeof avatar === 'string' ? undefined : avatar?.bucketUrl}
          name={name}
        />
      )}
      <Content className={clsx(userCellClasses.content, classes?.content)}>
        {typeof title === 'string' ? (
          <Title className={clsx(userCellClasses.title, classes?.title)}>{title}</Title>
        ) : (
          title
        )}
        {subtitle ? (
          <>
            {typeof subtitle === 'string' ? (
              <Subtitle className={clsx(userCellClasses.subtitle, classes?.subtitle)} noWrap>
                {subtitle}
              </Subtitle>
            ) : (
              subtitle
            )}
          </>
        ) : null}
      </Content>
      {typeof action === 'string' ? (
        <Action className={clsx(userCellClasses.action, classes?.action)}>{action}</Action>
      ) : (
        action
      )}
    </Root>
  );
};

export default UserCell;
